export enum TutoringKind {
  onSiteTutoring = 'onSiteTutoring',
  onlineTutoring = 'onlineTutoring',
  tutoringSchools = 'Tutoring schools',
}
